import styled from '@emotion/styled';

export const UploadImageWrapper = styled.div`
    font-size: small;
    width: 300px;
    .redBorder{
      border-width: medium;
      border-color: red;
      border-style: solid;
    }
    & > img {
        width: 300px;
        height: 180px;
        object-fit: cover;
    }
`;

export const TextWrapper = styled.div`
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    font-size: small;
`;

export const Headline = styled.div`
    margin-top: 0.5rem;
    display: flex;
    background-color: lightgrey;
    justify-content: flex-end;
`;

export const BrowseLabel = styled.div`
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
    border: none;
`;

export const Label = styled.label`
    display: inline-block;
    width: 100%;
`;
